import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './components/App'
import reportWebVitals from './reportWebVitals';

const app = ReactDOM.createRoot(document.getElementById('app'));
app.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
